import styled from "styled-components";

export const WrapFooter = styled.div`
    font-size: 14px;
    padding-top:10px;
    padding-bottom: 10px;
    margin-top:20px;
    margin-bottom:20px;
    /* font-weight:bold; */
`;